import 'react-app-polyfill/ie11'
import 'core-js/es/object'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import * as serviceWorker from './ServiceWorker'
import React from 'react'
import AppSwitch from './containers/AppSwitch'
import Amplify, { Auth, I18n } from 'aws-amplify'
import Registration from './containers/Registration'
import Login from './containers/Login'
import config from './configuration/config'
import awsconfig from './aws-exports'
import { Provider } from 'react-redux'
import { store } from './redux'
import notification from 'antd/lib/notification'
import { Authenticator, SignIn, SignUp, Greetings } from 'aws-amplify-react'
import './styles/App.css'

Sentry.init({
    dsn: config.Sentry.dsn,
    release: `bss@${process.env.REACT_APP_VERSION}`,
    environment: process.env.REACT_APP_STAGE,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.2,
})

const oauth = {
    domain: 'sso.bssnet.com',
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://guardian.bssnet.com',
    redirectSignOut: 'https://guardian.bssnet.com/saml2/logout',
    responseType: 'code',
}

const authScreenLabels = {
    en: {
        'Reset your password': 'Reset your Password - lower case only',
    },
}

Auth.configure(awsconfig)
Auth.configure({ oauth })
I18n.setLanguage('en')
I18n.putVocabularies(authScreenLabels)

Amplify.configure({
    API: {
        aws_appsync_graphqlEndpoint: config.AppSync.graphqlEndpoint,
        aws_appsync_region: config.AppSync.region,
        aws_appsync_authenticationType: config.AppSync.authenticationType,
    },
})

if (process.env.NODE_ENV === 'production') {
    serviceWorker.register({
        onUpdate: (registration) => {
            const waitingServiceWorker = registration.waiting
            if (waitingServiceWorker) {
                waitingServiceWorker.addEventListener('statechange', (event) => {
                    if (event.target.state === 'activated') {
                        notification.open({
                            message: 'New content available',
                            description:
                                'New content is available and will be used when all tabs for this page are closed.',
                            onClick: () => {
                                window.location.reload()
                            },
                        })
                    }
                })
                waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' })
            }
        },
    })
} else {
    serviceWorker.unregister()
}

const BSSTheme = {
    a: {
        color: '#0090ff',
    },
    button: {
        backgroundColor: '#0090ff',
        borderColor: '#0090ff',
        borderRadius: 10,
    },
}

const Main = () => (
    <Provider store={store}>
        <Authenticator theme={BSSTheme} hide={[Greetings, SignIn, SignUp]}>
            <AppSwitch />
            <Login override={'SignIn'} />
            <Registration override={'SignUp'} />
        </Authenticator>
    </Provider>
)

export default Main
